module.exports = __webpack_public_path__ + "static/media/Illus-Loyalty.96a3d512.png";